import { TableColumnsType } from "antd"
import { IAccessRole } from "@/types/dags"
import { useGetAccessRoles } from "@/hooks/useDags"
import dayjs from "dayjs"
import TableCustom from "@components/table"

const AccessesPage = () => {
  const { data, isLoading } = useGetAccessRoles()

  const columns: TableColumnsType<IAccessRole> = [
    {
      title: "Name",
      key: "name",
      dataIndex: "name",
    },
    {
      title: "Description",
      key: "description",
      dataIndex: "description",
    },
    {
      title: "Accesses",
      key: "accesses",
      dataIndex: "accesses",
      render: (accesses: string[]) => accesses.join(', '), // Render accesses as comma-separated string
    },
    {
      title: "Date Created",
      key: "dateCreated",
      dataIndex: "dateCreated",
      render: (text: Date) => dayjs(text).format("DD/MM/YYYY"),
    },
    {
      title: "Schema Version",
      key: "schemaVersion",
      dataIndex: "schemaVersion",
    },
  ]

  return (
    <div>
      <TableCustom
        rowKey={"_id"}
        columns={columns}
        dataSource={data}
        loading={isLoading}
        size={"small"}
      />
    </div>
  )
}

export default AccessesPage
